import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Button from "@mui/material/Button";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import CustomSelect from "../CustomComponents/CustomSelect";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import MomentUtils from "@date-io/moment";
import WeekPicker from "../../TimesheetItems/WeekPicker";
import moment from "moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import { MuiThemeProvider } from '@material-ui/core/styles'
import { muiThemeDesign } from '../../mui-theme-design';
import { muiThemePicker } from '../../mui-theme-design';
import { logger,checkAuthentication, muiLoaderOptionsWithoutMUIDataTable } from '../../utils';
import { Box, Container } from '@mui/material';
import HandelPOBillingReport from './HandelPOBillingReport'
import TextField from "@mui/material/TextField";

export default function ReportBillingPO () {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [day, setDay] = React.useState(new Date());
    const [POChoices, setPOChoices] = React.useState([]);
    const [invoiceChoices, setInvoiceChoices] = React.useState([]);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [Discount, setDiscount] = React.useState(0)
    const [PO, setPO] = React.useState(1);
    const [invoice, setInvoice] = React.useState(0);
    const [list, setList] = React.useState([])
    const [overTime, setsOverTime] = React.useState([])
    const [expand, setExpand] = React.useState(false);
    const [display, setDisplay] = React.useState(false);
	const [isLoading, setIsLoading] = React.useState(true);
	const [isLoading1, setIsLoading1] = React.useState(true);
   

    const initialValues = {
        POID: '',
        invoice: '',
    };
    
    const validFormSchema = Yup.object({
        POID: Yup
            .string('Select a PO')
            .required('PO selection Required'),
        invoice: Yup
            .string('Select a invoice')
            .required('invoice selection Required'),
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
        	  POID: values.POID,
            Name: values.POName,
            EffectiveDate: moment(values.effective),
        };
        logger("Trigger PO " + msg.POID)
        logger("Trigger Date " + msg.EffectiveDate)
     //   handleBillingPOCallback(msg);
        handleClose();
    })

    const setChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setPOChoices(choices);
    }

    React.useEffect(() => {
    //	logger("In UseEffect")
    	checkAuthentication();
        if (refresh) {
             fetch('/api/PO/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoices(json));

            fetch(`/api/invoice/dropdown/${PO}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setInvoiceChoices(json);
					setIsLoading1(false);
				});

            setRefresh(false);
        }
    })

    const handleGenerate = () => {
		setOpenLogs(true);
        logger(`handleGenerate`)
        fetch(`/api/BillingInvoice/${PO}/${invoice}`, {
            method: 'GET',
        })
            .then(res => res.json())
            .then(json => {
                logger('output', json)
                setDataSet(json)
                GetOverTime(json[0].SOWID, json[0].IsBilled, json[0].DiscountID, json[0].EndDate)
            })
        //`/api/InvoiceBreakdown/:${req.params.InvoiceID}`
        fetch(`/api/InvoiceBreakdown/${invoice}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                logger("get invoices", json);
                setList(json);
                setIsLoading(false);
            })
    };

    const handleClickOpen = () => {
        setRefresh(true)
        setOpen(true)
    };   

    const handleClose = () => {
     //   setPOChoices(0);
        setOpen(false);
    };

    const handleCloseForLogs = () => {
        setOpenLogs(false);
        setExpand(false);
    };

    const applyDiscount = (price) => {
        var getPrice = Discount.Discount / 100;

        var totalValue = price - (price * getPrice)
        logger(totalValue.toFixed(2));
        return totalValue.toFixed(2);
    }
	
	 const grandTotal = (Labor, Expense) => {
	    let res;
        if (Expense>0) {
			const discountedLabor = applyDiscount(parseFloat(Labor).toFixed(2));
			logger("discountedLabor",discountedLabor)
            let tmpTotal = parseFloat(discountedLabor) + parseFloat(Expense)
            logger("tmpTotal", tmpTotal)
            let res = parseFloat(tmpTotal).toFixed(2)
            logger(`GT with Exp`, res)
            return res;
        } else {
            const tmpTotal = applyDiscount(parseFloat(Labor).toFixed(2))
            let res = parseFloat(tmpTotal).toFixed(2)
            logger(`GT no Exp`, res)
            return res;
        }
         return res;
    }
	
	
    const calculateRate = (rate, flagType) => {
        if (overTime.length) {
            if (flagType === 'OT') {
                return rate * overTime[0].OverTimeWeek;
            } else if (flagType === 'WND') {
                return rate * overTime[0].OverTimeWeekEnd;
            } else if (flagType === 'HOL') {
                return rate * overTime[0].OverTimeHoliday;
            } else {
                return rate;
            }
        }
    };

    const GetOverTime = async (sow, IsBilled, DiscountID, Date) => {
        await fetch(`/api/SOW/OverTime/${sow}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setsOverTime(json))

        if (IsBilled == 1) {
            fetch(`/api/DiscountID/${DiscountID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setDiscount(json[0]));
        } else {
           /* fetch(`/api/Discount_Active/${Date}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setDiscount(json));*/
        }
    };

    const getTotal = () => {
        let total = 0
        list.map((item, index) => {
			const byteArray = new Uint8Array(item.Rate.data);
			const textDecoder = new TextDecoder();
			const res = textDecoder.decode(byteArray);
			const r = parseFloat(res).toFixed(2);
            total += calculateRate(r, item.FlagType) * item.Hours
        })
        return total.toFixed(2)
    };
 
    return (
        <div>
        <MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                Invoice Generate Report
            </Button>
             <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                           edge="start"
                                           color="inherit"
                                           onClick={handleClose}
                                           aria-label="close"
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Generate Invoice Report
                                        </Typography>
                                            <Button autoFocus color="inherit" onClick={handleGenerate}>
                                            Generate
                                            </Button>
                                            <HandelPOBillingReport PO={PO} invoiceID={invoice} display={display} />
                                            <Tooltip title="display username on download" placement="top-end">
                                                <Checkbox defaultChecked={display} color="default" onClick={() => { setDisplay(!display), setRefresh(true); }} />
                                            </Tooltip>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Invoice Report:</DialogTitle>    
                                {isLoading1 && POChoices.length===0 ? muiLoaderOptionsWithoutMUIDataTable() :        
                                 <div>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <InputLabel htmlFor="POSelection">PO Name</InputLabel>
                                            <CustomSelect
                                                name="POID"
                                                id="outlined-POSelection"
                                                options={POChoices}
                                                onChange={(e) => {
													setIsLoading1(true);
                                                    setPO(e.target.value);
                                                    setRefresh(true)
                                                }}
                                                value={PO}
                                                label="POID"
                                            />
                                        </FormControl>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <InputLabel htmlFor="POSelection">invoice</InputLabel>
                                            <CustomSelect
                                                name="invoice"
                                                id="outlined-POSelection"
                                                options={invoiceChoices}
                                                onChange={(e) => {
                                                    setInvoice(e.target.value);
                                                }}
                                                value={invoice}
                                                label="invoice"
                                            />
                                        </FormControl>
                                        {isLoading1 && <FormControl sx={{ m: 1, width: 220 }}>
                                            { muiLoaderOptionsWithoutMUIDataTable() }
                                        </FormControl>}
                                </div>
                                }
                            </Form>
                        )}
                        </Formik>
                        <Dialog open={openLogs} onClose={handleCloseForLogs}  maxWidth="1400px" scroll="paper" overflow-y="hidden">
                            <DialogContent >
                                    {isLoading ? muiLoaderOptionsWithoutMUIDataTable() :
                                    dataSet.map((value, index) => {
                                        return (
                                            <Box key={index}>
                                                <DialogTitle>
                                                <IconButton edge="start" color="inherit" onClick={handleCloseForLogs} aria-label="close"> <CloseIcon /> </IconButton>
                                                {moment.utc(value.StartDate).format('MMMM')}</DialogTitle>
                                                <p>{moment.utc(value.StartDate).format('MM/DD/YYYY')}-{moment.utc(value.EndDate).format('MM/DD/YYYY')}</p>
                                                <p>INVOICE REQUST_{value.PoNumber}_{moment.utc(value.StartDate).format('MMMM')}</p>
                                                <p><b>PO#:</b>{value.PoNumber}<br/>
                                                    <b>Name:</b>{value.Name}</p>
                                                <div>
                                                <b>Discount Rate:</b>{Discount.Discount}% </div>
                                                <div><b>RAW Labor:</b>${getTotal()} </div> 
                                               	<div>
                                                 <b>Discounted Labor:</b>${applyDiscount(getTotal())} </div>
                                                 <div>
                                                 <b>Expenses:</b>${value.TotalExpenses}  </div>
                                                 <div>
                                                  <b>Invoice Total:</b> ${grandTotal(getTotal(), value.TotalExpenses)}
                                                    </div>
                                                <p><b>Sold To:</b>{value.SoldTo}<br/>
                                                    <b>Ship To:</b>{value.ShipTo}</p>

                                                <p><b>CostCenter:</b>{value.NameCostCenter}<br/>
                                                    <b>CostCenter#:</b>{value.CostCenter}<br/>
                                                    <b>Invoice Amount:</b>{value.InvoiceAmount}</p>

                                                <p>
                                                    <b>Owner:</b>{value.Owner}<br/>
                                                    <b>Email:</b>{value.Email}<br />
                                                    <b>Email Group:</b>{value.EmailGroup}
                                                </p>
                                            </Box>
                                        );
                                    })}
                            </DialogContent>
                        </Dialog>
                </DialogContent>                
            </Dialog>
            </MuiThemeProvider>
        </div>
    );
}
 